var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  x: 1,
  y: 1,
  fill: "currentColor",
  rx: 7
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeMiterlimit: 16,
  strokeWidth: 1.5,
  d: "m6.5 5 3 3-3 3",
  style: {
    mixBlendMode: "difference"
  }
}));
export default SvgArrowRight16;